import { StageEntityId as S } from "@perxis-auto/trade-in-sdk/types";
const A = {
  [S.STAGE_1]: 1,
  [S.STAGE_2]: 1,
  [S.STAGE_3]: 2,
  [S.STAGE_4]: 2,
  [S.SUCCESS]: 3
}, _ = {
  [S.STAGE_1]: "Ваш автомобиль",
  [S.STAGE_2]: "Ваш автомобиль",
  [S.STAGE_3]: "Параметры автомобиля",
  [S.STAGE_4]: "Параметры автомобиля",
  [S.SUCCESS]: "Расчет стоимости"
}, T = 3;
export {
  T as MAX_STAGE_NUMBER,
  A as STAGE_NUMBER_MAP,
  _ as STAGE_TITLE_MAP
};
